module.exports = __webpack_public_path__ + "img/31.c8022a0f.jpg";